import React from 'react';

interface Props {
    lastFetched: Date | null;
    onRefresh: () => void;
}

const FreshnessBar: React.FC<Props> = ({ lastFetched, onRefresh }) => {
    if (!lastFetched) return null;
    return (
        <div className="flex items-center justify-end gap-2 text-[10px] text-semantic-text-secondary/60">
            <span>Updated {lastFetched.toLocaleTimeString()}</span>
            <button
                onClick={onRefresh}
                className="p-0.5 rounded hover:bg-semantic-bg-secondary transition-colors"
                title="Refresh"
            >
                <svg className="w-3 h-3" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 4v4h4" /><path d="M15 12v-4h-4" />
                    <path d="M13.5 6.5A6 6 0 0 0 3 4.5L1 8m14 0l-2 3.5a6 6 0 0 1-10.5-2" />
                </svg>
            </button>
        </div>
    );
};

export default FreshnessBar;
